<template>
  <div id="theater" class="section theaters columns is-gapless is-mobile is-centered">
    <div class="section--main--holder column is-12-mobile is-10-desktop">
      <section class="section--main">
        <h2 class="section--title centered">
          <img src="/static/img/titles/Theater.png" alt="Theaters">
          <strong class="seo">Theaters</strong>
        </h2>

        <table v-if="theatersData" class="table">
          <thead>
            <tr>
              <th>地域</th>
              <th>劇場名</th>
              <th>電話番号</th>
              <th>公開日</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="district in theatersData">
              <tr class="district" v-bind:key="district.id">
                <td colspan="4">{{district.theaters_district_name}}</td>
              </tr>
              <theater-item :theater="theater" v-for="theater in district.theaters_district_list" v-bind:key="theater.id"></theater-item>
            </template>
          </tbody>
        </table>

        <ul v-if="theatersData" class="comment--list main_cast">
          <li v-for="district in theatersData" v-bind:key="district.id" class="comment--item">
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TheatersItem from '@/components/TheatersItem'
import axios from '@/services/axios.js'

Vue.component('theater-item', TheatersItem)

export default {
  name: 'theaters',
  data () {
    return {
      theatersData: null
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      axios.get('wp-json/wp/v2/pages?slug=theaters')
        .then(response => {
          this.theatersData = response.data[0].acf.theaters_districts
        })
        .catch(e => { console.log(e) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Theaters.vue